import { liveFeedInputs } from './feedInputs';

// The Data Analyst Agent form's wire mapping, out of the page so it can be tested without rendering
// one. mapSubmitPayload is what ModeContext hands to the shared query machinery and what the page's
// own kickoff calls; invalidIdsFrom400 reads the one 400 shape Rails answers with for a rejected
// attachment, CSV or feed.

export const mapSubmitPayload = (apiFormData) => {
  const { question, selectedCsvDocs, selectedFeedInputs, noRetrieval, onlySources, excludeSources } = apiFormData;

  const payload = { request: question };

  if (Array.isArray(selectedCsvDocs) && selectedCsvDocs.length) {
    payload.csv_doc_ids = selectedCsvDocs.map((d) => d.id);
  }
  // The wire entries only. Each item wraps its entry with client-side facts (its size, the company
  // chips behind its subtitle) that fapi's `extra: forbid` entry model would refuse. An item whose
  // rows were released after a kickoff is a summary for the session card, not something to send:
  // its entry would claim a row_count over zero rows and fapi would reject the whole submit.
  const live = liveFeedInputs(selectedFeedInputs);
  if (live.length) {
    payload.feed_inputs = live.map((item) => item.entry);
  }
  if (noRetrieval) {
    payload.no_retrieval = true;
  }
  if (Array.isArray(onlySources) && onlySources.length) {
    payload.only_sources = onlySources;
  }
  if (Array.isArray(excludeSources) && excludeSources.length) {
    payload.exclude_sources = excludeSources;
  }

  return payload;
};

// Rails rejects a bad attachment with `{ error, invalid_doc_ids }` for a CSV and, mirroring it,
// `{ error, invalid_feed_ids }` for a feed. Doc ids are numbers; feed ids are strings. Either list
// may be absent, and a 400 carrying neither is an ordinary error for the page's fallback branch.
export const invalidIdsFrom400 = (data) => {
  const csvIds = Array.isArray(data?.invalid_doc_ids)
    ? data.invalid_doc_ids.filter((id) => typeof id === 'number')
    : [];
  const feedIds = Array.isArray(data?.invalid_feed_ids)
    ? data.invalid_feed_ids.filter((id) => typeof id === 'string' && id)
    : [];
  return { csvIds, feedIds, reason: (data && data.error) || null };
};
